exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".label-placeholder{display:inline-block}.form-container .btn{width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-search/vendor-search.component.css"],"names":[],"mappings":"AAAA,mBACI,oBAAsB,CACzB,qBAGG,UAAY,CACf","file":"vendor-search.component.css","sourcesContent":[".label-placeholder {\n    display: inline-block;\n}\n\n.form-container .btn {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-search/vendor-search.component.css
// module id = LfX5
// module chunks = 0